// A stamp "pack" is a fixed set of pre-made illustrations (not tinted or
// generated per business) — one image per stamp position, in this order.
// A business type can offer more than one pack (three cafetería styles
// today); the business picks one and it's saved as loyalty.stampPackId.
export type StampPackId = 'cafeteria' | 'cafeteria-grabado' | 'cafeteria-medallones';

const PACKS: Record<StampPackId, { label: string; images: { file: string; label: string }[] }> = {
  cafeteria: {
    label: 'Clásico',
    images: [
      { file: '01-taza.png', label: 'Taza' },
      { file: '02-granos.png', label: 'Granos' },
      { file: '03-vaso-para-llevar.png', label: 'Vaso para llevar' },
      { file: '04-croissant.png', label: 'Croissant' },
      { file: '05-cafetera-moka.png', label: 'Cafetera moka' },
      { file: '06-prensa-francesa.png', label: 'Prensa francesa' },
      { file: '07-capuchino.png', label: 'Capuchino' },
      { file: '08-molino.png', label: 'Molino' },
      { file: '09-filtro.png', label: 'Filtro' },
      { file: '10-galleta.png', label: 'Galleta' },
    ],
  },
  'cafeteria-grabado': {
    label: 'Grabado',
    images: [
      { file: '01-cafe-helado.png', label: 'Café helado' },
      { file: '02-chemex.png', label: 'Chemex' },
      { file: '03-tetera-cuello-cisne.png', label: 'Tetera de cuello de cisne' },
      { file: '04-portafiltro.png', label: 'Portafiltro' },
      { file: '05-rama-de-cafe.png', label: 'Rama de café' },
      { file: '06-saco-de-cafe.png', label: 'Saco de café' },
      { file: '07-affogato.png', label: 'Affogato' },
      { file: '08-dos-espressos.png', label: 'Dos espressos' },
      { file: '09-cafe-corazon.png', label: 'Café en forma de corazón' },
      { file: '10-cafe-para-compartir.png', label: 'Café para compartir' },
    ],
  },
  'cafeteria-medallones': {
    label: 'Medallones',
    images: [
      { file: '01-capuchino.png', label: 'Capuchino' },
      { file: '02-grano-de-cafe.png', label: 'Grano de café' },
      { file: '03-cafetera-moka.png', label: 'Cafetera moka' },
      { file: '04-croissant.png', label: 'Croissant' },
      { file: '05-molino.png', label: 'Molino' },
      { file: '06-prensa-francesa.png', label: 'Prensa francesa' },
      { file: '07-espresso.png', label: 'Espresso' },
      { file: '08-rama-de-cafe.png', label: 'Rama de café' },
      { file: '09-cafe-para-llevar.png', label: 'Café para llevar' },
      { file: '10-chemex.png', label: 'Chemex' },
    ],
  },
};

const PACKS_BY_TYPE: Record<string, StampPackId[]> = {
  cafeteria: ['cafeteria', 'cafeteria-grabado', 'cafeteria-medallones'],
};

// All packs a business type can pick from — defaults unknown types to the
// cafetería lineup so every business still gets real stamp art to choose.
export function packIdsForType(businessType?: string): StampPackId[] {
  return PACKS_BY_TYPE[businessType ?? ''] || PACKS_BY_TYPE.cafeteria;
}

export function listPacksForType(businessType?: string) {
  return packIdsForType(businessType).map((id) => ({ id, ...PACKS[id] }));
}

export function getStampPack(businessType?: string, packId?: string) {
  const available = packIdsForType(businessType);
  const id: StampPackId = (packId && available.includes(packId as StampPackId) ? packId : available[0]) as StampPackId;
  return { id, ...PACKS[id] };
}

export function stampImageUrl(packId: StampPackId, file: string) {
  return `/assets/stamps/${packId}/${file}`;
}
